import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	title: {
		id: 'trial.dodo.ratings.title',
		defaultMessage: 'More than 100 million people have downloaded Calm',
		description: 'dodo ratings title',
	},
	review: {
		id: 'trial.dodo.ratings.review',
		defaultMessage:
			'“This app is a complete life saver. It is an app everyone should have. My 5 year old never goes a night without it and myself too. I literally use it through most of my day listening to the music for focus during the day and winding down before bed. Love the meditations, the voiceovers are all so tranquil too.” - Emily Smith',
		description: 'dodo ratings review',
	},
	ratings: {
		id: 'trial.dodo.ratings.ratings',
		defaultMessage: 'Over 1 million 5-star reviews',
		description: 'dodo ratings star rating',
	},
	buttonText: {
		id: 'trial.dodo.ratings.signup.buttonText',
		defaultMessage: 'Start Free Trial',
		description: 'dodo ratings button text',
	},
});
